// Shared schedule contracts consumed by BOTH the SST infrastructure definitions
// (infra/omnea-app-api/infra/*.ts, to provision EventBridge schedules) and the
// owning service's domain code (to derive action/entity types). Kept here — a
// dependency-free location both layers depend on — so infra no longer imports
// from apps/services, which lets `sst dev` stop watching the whole service tree.
//
// These are pure data. Derived types (ValueOf/EntityAndSchedules/Schedule) stay
// in each service's own module, which re-exports the const from here.

export const assessmentSchedule = {
  entity: 'assessment',
  actions: {
    submissionReminder: 'submissionReminder',
    startWorkflow: 'startWorkflow',
  },
} as const

export const renewalSchedule = {
  entity: 'renewal',
  actions: {
    submissionReminder: 'submissionReminder',
    startWorkflow: 'startWorkflow',
  },
} as const

export const riskSchedule = {
  entity: 'risk',
  actions: {
    notifyRiskOwners: 'notifyRiskOwners',
  },
} as const

export const goodsReceiptingReminderSchedule = {
  entity: 'purchaseOrder',
  actions: {
    goodsReceiptingReminder: 'goodsReceiptingReminder',
  },
} as const

export const reportSchedule = {
  entity: 'customReport',
  actions: {
    generateScheduledReport: 'generateScheduledReport',
  },
} as const

export const requestStepSchedule = {
  entity: 'requestStep',
  actions: {
    deadlineReminder: 'deadlineReminder',
    adminEscalation: 'adminEscalation',
  },
} as const

export const pauseReminderSchedule = {
  entity: 'pause',
  actions: {
    pauseReminder: 'pauseReminder',
  },
} as const
